import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';

import AdminLoginPage from './pages/admin/AdminLoginPage';
import UserLoginPage  from './pages/user/UserLoginPage';
import AdminDashboard from './pages/admin/AdminDashboard';
import UserDashboard  from './pages/user/UserDashboard';
import SocietyDetail  from './pages/user/SocietyDetail';
import FYDetail       from './pages/accounting/FYDetail';
import AddEntryPage   from './pages/accounting/AddEntryPage';
import EditEntryPage  from './pages/accounting/EditEntryPage';
import IEAccount      from "./pages/ieaccount/index";
import ImportEntryPage from './pages/accounting/ImportEntryPage';

const AdminRoute = ({ children }) => {
  const { user, role, isLoading } = useAuth();
  if (isLoading) return <div className="loading-screen"><div className="spinner" /></div>;
  if (!user || role !== 'admin') return <Navigate to="/login" replace />;
  return children;
};

const UserRoute = ({ children }) => {
  const { user, role, isLoading, isImpersonating } = useAuth();
  if (isLoading) return <div className="loading-screen"><div className="spinner" /></div>;
  if (!user || (role !== 'user' && !isImpersonating)) return <Navigate to="/user/login" replace />;
  return children;
};

const AppRoutes = () => {
  const { user, role, isImpersonating } = useAuth();
  return (
    <Routes>
      <Route path="/login"      element={<AdminLoginPage />} />
      <Route path="/user/login" element={<UserLoginPage  />} />
      <Route path="/admin/*"    element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/dashboard"  element={<UserRoute><UserDashboard /></UserRoute>} />
      <Route path="/dashboard/society/:societyId"           element={<UserRoute><SocietyDetail /></UserRoute>} />
      <Route path="/dashboard/society/:societyId/fy/:fyId"  element={<UserRoute><FYDetail /></UserRoute>} />
      <Route path="/dashboard/society/:societyId/fy/:fyId/add/:type" element={<UserRoute><AddEntryPage /></UserRoute>} />
      <Route path="/dashboard/society/:societyId/fy/:fyId/edit/:type/:txnId" element={<UserRoute><EditEntryPage /></UserRoute>} />
      <Route path="/" element={
        user
          ? (role === 'admin' && !isImpersonating ? <Navigate to="/admin" replace /> : <Navigate to="/dashboard" replace />)
          : <Navigate to="/login" replace />
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
      <Route path="/dashboard/society/:societyId/fy/:fyId/import/:type" element={<UserRoute><ImportEntryPage /></UserRoute>} />
    </Routes>
  );
};

const App = () => (
  <ThemeProvider>
  <BrowserRouter>
    <AuthProvider>
      <Toaster position="top-right" toastOptions={{
        style: { background:'#172640', color:'#EDF2F7', border:'1px solid rgba(245,166,35,0.18)', fontFamily:"'DM Sans', sans-serif", fontSize:'0.85rem', borderRadius:'8px' },
        success: { iconTheme: { primary:'#2DD4A0', secondary:'#172640' } },
        error:   { iconTheme: { primary:'#F06B6B', secondary:'#172640' } },
      }} />
      <AppRoutes />
    </AuthProvider>
  </BrowserRouter>
  </ThemeProvider>
);

export default App;
